"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
const react_1 = __importStar(require("react"));
const class_variance_authority_1 = require("class-variance-authority");
const switchStyles = (0, class_variance_authority_1.cva)("relative inline-block w-11 h-6 rounded-full transition-all duration-300", {
    variants: {
        state: {
            unchecked: "bg-grey300",
            checked: "bg-grey800",
        },
    },
    defaultVariants: {
        state: "unchecked",
    },
});
const knobStyles = (0, class_variance_authority_1.cva)("absolute top-[2px] left-[2px] w-5 h-5 bg-brandWhite rounded-full transition-all duration-300 transform", {
    variants: {
        state: {
            unchecked: "translate-x-0",
            checked: "translate-x-5",
        },
    },
    defaultVariants: {
        state: "unchecked",
    },
});
const Switch = ({ className, uncheckedBgColor = "bg-grey300", checkedBgColor = "bg-grey800", ariaLabel = "Toggle switch", onClick, // ✅ Destructure it
 }) => {
    const [isChecked, setIsChecked] = (0, react_1.useState)(false);
    const toggleSwitch = () => {
        setIsChecked((prev) => !prev);
        if (onClick) {
            onClick(); // ✅ Call the external handler
        }
    };
    const handleKeyDown = (event) => {
        if (event.key === " " || event.key === "Enter") {
            event.preventDefault(); // Prevent default scrolling behavior for space key
            toggleSwitch();
        }
    };
    return (react_1.default.createElement("div", { className: `tab ${switchStyles({
            state: isChecked ? "checked" : "unchecked",
        })} ${isChecked ? checkedBgColor : uncheckedBgColor} ${className || ""}`, role: "switch", "aria-checked": isChecked, "aria-label": ariaLabel, tabIndex: 0, onClick: toggleSwitch, onKeyDown: handleKeyDown, "data-state": isChecked ? "checked" : "unchecked" },
        react_1.default.createElement("span", { className: knobStyles({ state: isChecked ? "checked" : "unchecked" }) })));
};
exports.Switch = Switch;
